import { Link } from "@heroui/react";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/api";
import { toast } from "react-toastify";
import { TableBuilder } from "@/app/components/tables/tableBuilder.tsx";
import { ColumnType } from "@/app/components/tables/tableTypes.ts";
import { RenterRequisite } from "@/api/requisites/requisites";

export function RenterRequisitesPage() {
  const { id } = useParams();
  const [users, setUsers] = useState<RenterRequisite[]>([]);

  useEffect(() => {
    api.renters
      .listRequisites(Number(id))
      .then((response) => {
        setUsers(response.data);
      })
      .catch((err) => {
        console.log(err);
        toast.error("Произошла ошибка при загрузке реквизитов!");
      });
  }, [id]);

  return (
    <>
      <div className="flex flex-row flex-wrap gap-4 w-full">
        <div className="flex flex-col gap-2 max-md:flex-grow">
          <Link
            href={`/dashboard/renters/${id}`}
            className="flex flex-row items-center p-4 rounded-xl font-medium text-foreground-600"
          >
            Информация о арендаторе
          </Link>
          <Link
            href={`/dashboard/renters/${id}/offices`}
            className="flex flex-row items-center p-4 rounded-xl font-medium text-foreground-600"
          >
            Офисы в аренде
          </Link>
          <Link
            href={`/dashboard/renters/${id}/employees`}
            className="flex flex-row items-center p-4 rounded-xl font-medium text-foreground-600"
          >
            Сотрудники арендатора
          </Link>
          <Link
            href={`/dashboard/renters/${id}/requisites`}
            className="flex flex-row items-center p-4 rounded-xl font-medium text-primary bg-primary bg-opacity-10"
          >
            Реквизиты
          </Link>
        </div>
        <div className="flex-grow flex flex-col gap-2">
          <div className="w-full flex flex-col gap-1 bg-white dark:bg-zinc-900 p-4 rounded-xl border-2 border-foreground-200 dark:border-foreground-100">
            <div className="flex flex-row w-full items-center">
              <div className="flex flex-row w-full gap-4 items-center">
                <span className="font-medium">Реквизиты арендатора</span>
              </div>
            </div>
            <TableBuilder
              displayOptions={false}
              displaySearch={false}
              removeWrapper={true}
              columns={[
                {
                  label: "Название счета",
                  key: "display_name",
                  type: ColumnType.String,
                  sortable: true,
                },
                {
                  label: "ИНН",
                  key: "inn",
                  type: ColumnType.String,
                  sortable: true,
                },
                {
                  label: "КПП",
                  key: "kpp",
                  type: ColumnType.String,
                  sortable: true,
                },
                {
                  label: "ОГРН",
                  key: "ogrn",
                  type: ColumnType.String,
                  sortable: true,
                },
                {
                  label: "Счёт в банке",
                  key: "bank_account",
                  type: ColumnType.String,
                  sortable: true,
                },
                {
                  label: "Название банка",
                  key: "bank_name",
                  type: ColumnType.String,
                  sortable: true,
                },
                {
                  label: "БИК",
                  key: "bik",
                  type: ColumnType.String,
                  sortable: true,
                },
                {
                  label: "Корр. счёт",
                  key: "correspondent_account",
                  type: ColumnType.String,
                  sortable: true,
                },
              ]}
              data={users}
              rowsPerPage={10}
              defaultSortDescriptor={{
                column: "username",
                direction: "ascending",
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
}
